<template>
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 0C2.4599 0 0 2.46011 0 5.5C0 8.5401 2.46011 11 5.5 11C8.5401 11 11 8.53989 11 5.5C11 2.4599 8.53987 0 5.5 0ZM5.5 10.1406C2.93492 10.1406 0.859375 8.06491 0.859375 5.5C0.859375 2.93492 2.93509 0.859375 5.5 0.859375C8.06508 0.859375 10.1406 2.93509 10.1406 5.5C10.1406 8.06508 8.06489 10.1406 5.5 10.1406Z"
      fill="#A6A6A6"
    />
    <path
      d="M5.5 4.60474C5.26268 4.60474 5.07031 4.79711 5.07031 5.03442V7.80146C5.07031 8.03878 5.26268 8.23115 5.5 8.23115C5.73732 8.23115 5.92969 8.03876 5.92969 7.80144V5.03442C5.92969 4.79711 5.73732 4.60474 5.5 4.60474Z"
      fill="#A6A6A6"
    />
    <path
      d="M5.5 4.07861C5.82037 4.07861 6.08008 3.8189 6.08008 3.49854C6.08008 3.17817 5.82037 2.91846 5.5 2.91846C5.17963 2.91846 4.91992 3.17817 4.91992 3.49854C4.91992 3.8189 5.17963 4.07861 5.5 4.07861Z"
      fill="#A6A6A6"
    />
  </svg>
</template>

<script>
export default {
  name: 'InfoIcon',
};
</script>

<style scoped></style>
